<template>
  <el-header class="header mw1340">
    <img src="../../assets/images/logo.png" alt="" class="fl logo mr22 mt20" />
    <img src="../../assets/images/logo-line.png" alt="" class="fl mr20 mt12" />
    <p class="fl title mr20">立法知识服务系统</p>
    <!-- <p class="fl welcome">欢迎您的来访！</p> -->
    <!-- @select="handleSelect" -->
    <el-menu
      active-text-color="#ffd04b"
      :default-active="activeIndex"
      @select="handleSelect"
      class="el-menu-demo1"
      mode="horizontal"
      :router="true"
    >
      <el-menu-item index="/index" v-if="token">
        首页
        <i class="iconfont icon-huabigongju-tuoyuan"></i>
      </el-menu-item>
      <el-menu-item index="/legislateKnowledgeBase">
        立法知识库
        <i class="iconfont icon-huabigongju-tuoyuan"></i>
      </el-menu-item>
      <el-submenu index="3" v-if="can_check_files == 'yes'">
        <template slot="title">
          智能审查
          <i class="iconfont icon-huabigongju-tuoyuan"></i>
        </template>
        <el-menu-item
          index="/recordReview/reviewTaskManage2"
          :route="{
            path: '/recordReview/reviewTaskManage',
            query: { type: 'newReview' },
          }"
          @click="newReviewFun"
          >新建审查</el-menu-item
        >
        <el-menu-item index="/recordReview/reviewTaskManage">审查任务管理</el-menu-item>
        <el-menu-item index="/recordReview/reviewReportManage">审查报告管理</el-menu-item>
        <el-menu-item index="/recordReview/reviewAnalyze">统计分析</el-menu-item>
      </el-submenu>
      <!-- <el-submenu index="3" v-else>
				<template slot="title">
					智能审查
					<i class="iconfont icon-huabigongju-tuoyuan"></i>
				</template>
				<el-menu-item @click="reviewPermFun">新建审查</el-menu-item>
				<el-menu-item @click="reviewPermFun">审查任务管理</el-menu-item>
				<el-menu-item @click="reviewPermFun">审查报告管理</el-menu-item>
				<el-menu-item @click="reviewPermFun">统计分析</el-menu-item>
			</el-submenu> -->
      <!-- <el-menu-item index="4">
                系统管理
                <i class="iconfont icon-huabigongju-tuoyuan"></i>
            </el-menu-item> -->
    </el-menu>
    <moreOperations ref="moreOperations" :key="token"></moreOperations>
    <personal :key="token"></personal>
  </el-header>
</template>
<script>
import { loginMixin } from "@/mixins/loginMixin";
//更多操作
import moreOperations from "./moreOperations.vue";
//event-bus
import bus from "../../api/event-bus.js";

export default {
  mixins: [loginMixin],

  props: ["data"],
  components: {
    moreOperations,
  },
  data() {
    return {
      activeIndex: "", //横向导航默认选中
      can_check_files: "", //是否有立法知识库的权限 "yes"有 "no"没有
      token: "",
    };
  },
  created() {
    //是否有立法知识库的权限
    // this.getCheckFun(); //是否有立法知识库的权限
    this.can_check_files = window.localStorage.getItem("can_check_files");
    this.token = window.localStorage.getItem("token");
    if (this.$route.path.indexOf("index") > -1) {
      this.activeIndex = "/index";
    } else if (this.$route.path.indexOf("legislateKnowledgeBase") > -1) {
      this.activeIndex = "/legislateKnowledgeBase";
    } else if (this.$route.path.indexOf("recordReview") > -1) {
      this.activeIndex = "/recordReview/reviewTaskManage";
    } else {
      this.activeIndex = window.localStorage.getItem("headActiveIndex");
    }
  },
  mounted() {
    //如果统一登录在别的网站退出了，立法系统也需要同步
    if (!this.getCookie("LID") && !this.getCookie("c_m_LinID") && this.token) {
      this.$refs.moreOperations.exit();
    }
  },
  methods: {
    getCookie(c_name) {
      if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          let c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) c_end = document.cookie.length;
          return document.cookie.substring(c_start, c_end);
        }
      }
      return "";
    },
    //是否有立法知识库的权限
    getCheckFun() {
      this.axios({
        method: "get",
        url: "/japi/user/is_has_permission/",
        params: {
          perm_codename_list: JSON.stringify(["can_check_files"]),
        },
      }).then((res) => {
        console.log("权限返回======");
        console.log(res);
        if (res.data.code == 200 || res.data.code == 403) {
          console.log("权限返回成功======");
          //判断浏览器是否支持 localStorage 这个属性
          if (!window.localStorage) {
            alert("您的浏览器不支持localstorage");
            return false;
          } else {
            this.can_check_files = res.data.data[0].can_check_files;
            //存储到window.localStorage
            window.localStorage.setItem(
              "can_check_files",
              res.data.data[0].can_check_files
            );
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //切换导航
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      window.localStorage.setItem("headActiveIndex", key);
    },
    //没有备案审查的权限时 弹窗提示
    reviewPermFun() {
      if (window.localStorage.getItem("token")) {
        if (this.can_check_files == "no") {
          this.$message({
            message: "没有权限！",
            type: "warning",
            duration: 3000,
          });
        }
      } else {
        this.$message({
          message: "请登录后查看！",
          type: "warning",
          duration: 3000,
        });
      }
    },

    //跳转审查任务管理页面
    newReviewFun() {
      //参数一：要传递的变量名 参数二：要传递的变量名所对应的值
      bus.$emit("newReview", "yes");
    },
  },
};
</script>
<style lang="scss">
.ecp_top-nav {
  display: none !important;
}
</style>

<style lang="scss" scoped>
.el-submenu__title {
  color: #ffd04b !important;
}
.el-submenu.is-active,
.el-menu-item.is-active {
  color: #ffd04b !important;
}
</style>
